import React, { useEffect, useState } from 'react'
import { useMap } from 'react-leaflet'
import L from 'leaflet'
import { createPortal } from 'react-dom'

/**
 * MapControl
 * A custom Leaflet control for React-Leaflet that renders React elements
 * at the specified control position (e.g., 'topleft', 'bottomright').
 */
const MapControl = ({ position = 'topleft', children }) => {
  const map = useMap()
  const [container, setContainer] = useState(null)

  useEffect(() => {
    const control = L.control({ position })

    control.onAdd = () => {
      const c = L.DomUtil.create('div', 'leaflet-control-custom')
      L.DomEvent.disableClickPropagation(c)
      setContainer(c)
      return c
    }

    control.addTo(map)
    return () => {
      control.remove()
    }
  }, [map, position])

  // Render children into the Leaflet control container via React Portal
  return container ? createPortal(children, container) : null
}

export default MapControl
